import { Injectable, Injector } from '@angular/core';
import { DataService } from './data.service';
import { ApiEndpoints } from '../../ApiEndpoints';

@Injectable({
  providedIn: 'root'
})
export class HouseViewsService extends DataService {

  constructor(injector: Injector) {
    super(injector);
  }

  // User house views
  getUserViews() {
    return this.getRequest(ApiEndpoints.myHouseViews);
  }

  getUserView(id: number) {
    return this.getRequest(`${ApiEndpoints.myHouseView}/${id}`);
  }

  createUserView(entity: any) {
    if (entity.id) {
      return this.putRequest(ApiEndpoints.myHouseView, entity);
    }
    return this.postRequest(ApiEndpoints.myHouseView, entity);
  }

  deleteUserView(entity: any) {
    return this.deleteRequest(ApiEndpoints.myHouseView, entity.id);
  }

  // Firm house views
  getFirmViews() {
    return this.getRequest(ApiEndpoints.firmHouseViews);
  }

  getFirmView(id: number) {
    return this.getRequest(`${ApiEndpoints.firmHouseView}/${id}`);
  }

  createFirmView(entity: any) {
    if (entity.id) {
      return this.putRequest(ApiEndpoints.firmHouseView, entity);
    }
    return this.postRequest(ApiEndpoints.firmHouseView, entity);
  }

  deleteFirmView(entity: any) {
    return this.deleteRequest(ApiEndpoints.firmHouseView, entity.id);
  }
}
